// extracted by mini-css-extract-plugin
export default {"scenes-edit":"ScenesEdit_scenes-edit__kYA4S","scenes-edit__wrapper":"ScenesEdit_scenes-edit__wrapper__CwzoU"};